import { ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { manualPackagingInstruction } from "../../Instructions";
import { CommonManualPackagingTextForNuGet, CommonManualPackagingTextForZip } from "../CommonRegistrationText";
export const ManualPackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging Node.js applications, we recommend using the <ExternalLink href={"cli"}>Octopus CLI</ExternalLink>.
        </p>
        <p>
            However, if you wish to package your Node.js applications manually (on your build output), creating <i>NuGet</i> or <i>Zip</i> packages yourself is an easy way to get started.
        </p>
        {CommonManualPackagingTextForNuGet}
        {CommonManualPackagingTextForZip}
    </div>);
ManualPackaging.displayName = "ManualPackaging"
export default manualPackagingInstruction(() => <ManualPackaging />);
